import { createHttp } from './http';

const api = createHttp({
  baseURL: '/'
});
export default api;
